// @ts-nocheck
import {ConfEnv} from "../../../../config/config";
import privateRequest from "../../../../Infra/http/private.request";

export const getTicketsService = async (page = 1, limit = 50) => {
  const url = `${ConfEnv.BASE_URL}/raffles/tickets?page=${page}&pageSize=${limit}`;
  return privateRequest.get(url);
};
